// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  type OperationDefinition,
  type OperationDisplayDefinition,
  type OperationPropertiesDefinition,
  type OperationServiceSpecificationDefinition,
  type OperationMetricSpecificationDefinition,
  type OperationLogSpecificationDefinition,
  type ErrorResponse,
  type ErrorDetail,
  type ErrorAdditionalInfo,
  type Registry,
  type RegistryProperties,
  KnownProvisioningState,
  type ProvisioningState,
  type Status,
  type NetworkRuleSet,
  KnownDefaultAction,
  type DefaultAction,
  type IPRule,
  KnownAction,
  type Action,
  type Policies,
  type QuarantinePolicy,
  KnownPolicyStatus,
  type PolicyStatus,
  type TrustPolicy,
  KnownTrustPolicyType,
  type TrustPolicyType,
  type RetentionPolicy,
  type ExportPolicy,
  KnownExportPolicyStatus,
  type ExportPolicyStatus,
  type AzureADAuthenticationAsArmPolicy,
  KnownAzureADAuthenticationAsArmPolicyStatus,
  type AzureADAuthenticationAsArmPolicyStatus,
  type EncryptionProperty,
  KnownEncryptionStatus,
  type EncryptionStatus,
  type KeyVaultProperties,
  type PrivateEndpointConnection,
  type PrivateEndpointConnectionProperties,
  type PrivateEndpoint,
  type PrivateLinkServiceConnectionState,
  KnownConnectionStatus,
  type ConnectionStatus,
  KnownActionsRequired,
  type ActionsRequired,
  KnownPublicNetworkAccess,
  type PublicNetworkAccess,
  KnownNetworkRuleBypassOptions,
  type NetworkRuleBypassOptions,
  KnownZoneRedundancy,
  type ZoneRedundancy,
  KnownRoleAssignmentMode,
  type RoleAssignmentMode,
  type Sku,
  KnownSkuName,
  type SkuName,
  KnownSkuTier,
  type SkuTier,
  type IdentityProperties,
  type ResourceIdentityType,
  type UserIdentityProperties,
  type ProxyResource,
  type Resource,
  type SystemData,
  KnownCreatedByType,
  type CreatedByType,
  type TrackedResource,
  type RegistryUpdateParameters,
  type RegistryPropertiesUpdateParameters,
  type ImportImageParameters,
  type ImportSource,
  type ImportSourceCredentials,
  KnownImportMode,
  type ImportMode,
  type RegistryUsageListResult,
  type RegistryUsage,
  KnownRegistryUsageUnit,
  type RegistryUsageUnit,
  type RegistryListCredentialsResult,
  type RegistryPassword,
  type PasswordName,
  type RegenerateCredentialParameters,
  type GenerateCredentialsParameters,
  KnownTokenPasswordName,
  type TokenPasswordName,
  type GenerateCredentialsResult,
  type TokenPassword,
  type RegistryNameCheckRequest,
  type ContainerRegistryResourceType,
  type RegistryNameStatus,
  type PrivateLinkResource,
  type PrivateLinkResourceProperties,
  type CacheRule,
  type CacheRuleProperties,
  type CacheRuleUpdateParameters,
  type CacheRuleUpdateProperties,
  type CredentialSet,
  type CredentialSetProperties,
  type AuthCredential,
  KnownCredentialName,
  type CredentialName,
  type CredentialHealth,
  KnownCredentialHealthStatus,
  type CredentialHealthStatus,
  type CredentialSetUpdateParameters,
  type CredentialSetUpdateProperties,
  type ConnectedRegistry,
  type ConnectedRegistryProperties,
  KnownConnectedRegistryMode,
  type ConnectedRegistryMode,
  KnownConnectionState,
  type ConnectionState,
  type ActivationProperties,
  KnownActivationStatus,
  type ActivationStatus,
  type ParentProperties,
  type SyncProperties,
  type LoginServerProperties,
  type TlsProperties,
  KnownTlsStatus,
  type TlsStatus,
  type TlsCertificateProperties,
  KnownCertificateType,
  type CertificateType,
  type LoggingProperties,
  KnownLogLevel,
  type LogLevel,
  KnownAuditLogStatus,
  type AuditLogStatus,
  type StatusDetailProperties,
  type GarbageCollectionProperties,
  type ConnectedRegistryUpdateParameters,
  type ConnectedRegistryUpdateProperties,
  type SyncUpdateProperties,
  type Replication,
  type ReplicationProperties,
  type ReplicationUpdateParameters,
  type ReplicationUpdateParametersProperties,
  type ScopeMap,
  type ScopeMapProperties,
  type ScopeMapUpdateParameters,
  type ScopeMapPropertiesUpdateParameters,
  type Token,
  type TokenProperties,
  type TokenCredentialsProperties,
  type TokenCertificate,
  KnownTokenCertificateName,
  type TokenCertificateName,
  KnownTokenStatus,
  type TokenStatus,
  type TokenUpdateParameters,
  type TokenUpdateProperties,
  type Webhook,
  type WebhookProperties,
  KnownWebhookStatus,
  type WebhookStatus,
  KnownWebhookAction,
  type WebhookAction,
  type WebhookCreateParameters,
  type WebhookPropertiesCreateParameters,
  type WebhookUpdateParameters,
  type WebhookPropertiesUpdateParameters,
  type EventInfo,
  type Event,
  type EventRequestMessage,
  type EventContent,
  type Target,
  type Request,
  type Actor,
  type Source,
  type EventResponseMessage,
  type CallbackConfig,
  KnownVersions,
} from "./models.js";
